import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Auto-recover from stale chunk errors after a redeploy
const RELOAD_KEY = "__chunk_reloaded_at";
const handleChunkError = (msg: string) => {
  if (
    /Importing a module script failed|Failed to fetch dynamically imported module|Loading chunk .* failed/i.test(
      msg
    )
  ) {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    if (Date.now() - last > 10000) {
      sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
      window.location.reload();
    }
  }
};
window.addEventListener("error", (e) => handleChunkError(e.message || ""));
window.addEventListener("unhandledrejection", (e) =>
  handleChunkError(String((e.reason && e.reason.message) || e.reason || ""))
);

createRoot(document.getElementById("root")!).render(<App />);

